import React, { useEffect, useState } from 'react';
import './Account.css';
import userImage from '../../assets/images/userImage.png';
import { fetchUserData, updateUserActivity } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const Account = () => {
    const [user, setUser] = useState(null);
    const { logout } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        updateUserActivity();
        const getUserData = async () => {
            try {
                const userData = await fetchUserData();
                setUser(userData);
            } catch (error) {
                console.error('Failed to fetch user data:', error);
                handleLogout();
            }
        };

        getUserData();
    }, []);

    const handleLogout = () => {
        logout();
        navigate('/login');
    };

    if (!user) {
        return <div>Loading account details...</div>;
    }

    return (
        <div className="account-container">
            <div className="account-section user-profile">
                <img src={userImage} alt="User Profile" className="profile-pic" />
                <h2 className="user-username">{user.username}</h2>
                <h3 className="user-name">{user.firstName} {user.lastName}</h3>
                <p className="user-email">{user.email} <span className="user-verified">({user.verified ? 'Verified' : 'Unverified'})</span></p>
                <button onClick={handleLogout} className="account-logout-button">
                    Logout
                </button>
            </div>
            <div className="account-section account-balance">
                <h4>Balance:</h4>
                <p>
                    $ {(() => {
                        let balanceValue = '0.00';
                        if (user && user.balance !== null && user.balance !== undefined) {
                            if (typeof user.balance === 'object' && user.balance.$numberDecimal) {
                                balanceValue = user.balance.$numberDecimal;
                            } else {
                                balanceValue = user.balance.toString();
                            }
                        }
                        const numericBalance = parseFloat(balanceValue);
                        return isNaN(numericBalance) ? 'N/A' : numericBalance.toFixed(2);
                    })()}
                </p>
            </div>
            <div className="account-section account-actions">
                <button className="deposit-btn">Deposit</button>
                <button className="withdraw-btn">Withdraw</button>
            </div>
            <div className="account-section support-info">
                <h4>Need Help?</h4>
                <p>Contact our support team at <a href="mailto:support@onetimefantasy.com">support@onetimefantasy.com</a></p>
            </div>
        </div>
    );
};

export default Account;